import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class ReasonInactiveService {
  constructor(private http: HttpClientService) {}

  public inRange(from, to, model): Observable<any> {
    const options = {
      params: {
        from: from,
        to: to,
        model: model,
      },
    };
    return this.http
      .get("/api/reasons_inactives/in_date_range", options)
      .pipe(tap((_) => console.log("ReasonInactiveService.inRange: Ok.")));
  }

  public getReasons(): Observable<any> {
    return this.http
      .get("/api/reasons_inactives")
      .pipe(tap((_) => console.log("ReasonInactiveService.getReasons: Ok.")));
  }
}
